import classes from "./FeatureCard.module.css";

function renderHighlightedText(text, highlightText) {
  if (!text) return null;

  const highlights = Array.isArray(highlightText)
    ? highlightText
    : [highlightText];

  const validHighlights = highlights.filter(Boolean);

  if (!validHighlights.length) {
    return text;
  }

  const escapedHighlights = validHighlights.map((word) =>
    word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  );

  const regex = new RegExp(`(${escapedHighlights.join("|")})`, "gi");

  return text.split(regex).map((part, index) => {
    const isHighlighted = validHighlights.some(
      (word) => part.toLowerCase() === word.toLowerCase(),
    );

    return isHighlighted ? (
      <span key={index} className={classes.highlight}>
        {part}
      </span>
    ) : (
      part
    );
  });
}

export default function FeatureCard({
  sectionTitle = "",
  sectionDescription = "",
  highlightText = [],
  features = [],
}) {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        {(sectionTitle || sectionDescription) && (
          <div className={classes.header}>
            {sectionTitle && (
              <h2 className={classes.heading}>
                {renderHighlightedText(sectionTitle, highlightText)}
              </h2>
            )}

            {sectionDescription && (
              <p className={classes.paragraph}>
                {sectionDescription}
              </p>
            )}
          </div>
        )}

        {features.length > 0 && (
          <div className={classes.grid}>
            {features.map((feature, index) => (
              <article key={feature.id || feature.title} className={classes.feature}>
                {feature.icon && (
                  <div className={classes.icon} aria-hidden="true">
                    {feature.icon}
                  </div>
                )}

                <div className={classes.content}>
                  {feature.title && (
                    <h3 className={classes.title}>{feature.title}</h3>
                  )}

                  {feature.description && (
                    <p className={classes.description}>{feature.description}</p>
                  )}

                  {feature.link && (
                    <a href={feature.link} className={classes.link}>
                      {feature.linkText || "Learn More"}
                      <span aria-hidden="true">→</span>
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
